import { RefObject, useEffect, useRef } from 'react'

/**
 * Custom hook to detect clicks outside a ref element
 * Used for closing mobile sidebar overlay
 *
 * @param ref - React ref to the element to watch
 * @param handler - Callback function to execute when clicking outside
 */
export const useClickOutside = (
  ref: RefObject<HTMLElement>,
  handler: () => void
): void => {
  const savedHandler = useRef(handler)
  savedHandler.current = handler

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        savedHandler.current()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('touchstart', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('touchstart', handleClickOutside)
    }
  }, [ref])
}
